import _ from "lodash";

import React from "react";
import classes from "./DialogueBoxV2.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import { FormTextInput } from "UIComponents/InputTextField";
import { FormTextAreaInput } from "UIComponents/TextAreaInput";
import UIModal from "UIComponents/UIModal";
import RadioButtonList from "UIComponents/RadioButtonList";
import { isURL } from "Utils";
import { CloseOutlined } from "@toddle-edu/ds-icons";
import { Button, IconButton } from "@toddle-edu/ds-web";

class DialogueBoxV2 extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      promptText:
        _.get(props, "promptBoxType", "") === "RadioButton"
          ? _.first(props.promptDetail.options).value
          : _.get(props, "promptDetail.promptText", ""),
    };

    if (props.updateRef) {
      props.updateRef(this);
    }
  }

  onPromptTextChange = params => {
    this.setState({ promptText: params.promptText });
  };

  onRadioButtonOptionChange = ({ selectedOption }) => {
    this.setState({ promptText: selectedOption });
  };

  onClickContainer = event => {
    event.stopPropagation();
    event.preventDefault();
  };
  onClickButton2 = event => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    if (this.props.onClickButton2) {
      if (this.promptTextRef) {
        if (this.props.promptDetail.checkValidation) {
          const errorCount = this.promptTextRef.isValid();

          if (errorCount > 0) {
            return;
          }
        }
        this.props.onClickButton2(this.state.promptText);
      } else {
        this.props.onClickButton2();
      }
    }
    if (this.props.shouldCloseOnButtonClick) {
      this.props.toggleDialogueBoxDisplay();
    }
  };

  onClickButton1 = event => {
    event.stopPropagation();
    event.preventDefault();
    if (this.props.onClickButton1) {
      this.props.onClickButton1();
    }
    this.props.toggleDialogueBoxDisplay();
  };

  onPromptEnter = () => {
    this.onClickButton2();
  };

  onCancelClick = e => {
    e && e.stopPropagation();
    if (this.props.toggleDialogueBoxDisplay) {
      this.props.toggleDialogueBoxDisplay({ isCancel: true });
    }
  };

  customValidation = value => {
    const {
      promptDetail: { customValidationType },
    } = this.props;
    switch (customValidationType) {
      case "URL":
        if (isURL(value)) return "";
        else return "Please enter valid url";
      // break;
      default:
        return "";
      // break;
    }
  };

  renderPromptBoxComponent = () => {
    const {
      promptDetail: { customValidationType },
      promptBoxType,
      textAreaRows,
      testId,
    } = this.props;
    const { promptText } = this.state;

    switch (promptBoxType) {
      case "InputTextField":
        return (
          <FormTextInput
            name="promptText"
            placeholder={this.props.promptDetail.placeholder}
            label={this.props.promptDetail.label}
            updateInputField={this.onPromptTextChange}
            value={this.state.promptText}
            ref={ref => (this.promptTextRef = ref)}
            onEnter={this.onPromptEnter}
            autoFocus={true}
            customValidation={customValidationType && this.customValidation}
            testId={`${testId}-promptText`}
          />
        );
      case "RadioButton":
        return (
          <RadioButtonList
            ref={ref => (this.promptTextRef = ref)}
            options={this.props.promptDetail.options}
            value={promptText}
            updateInputField={this.onRadioButtonOptionChange}
            showErrorText={true}
            name="selectedOption"
          />
        );
      default:
        return (
          <FormTextAreaInput
            name="promptText"
            minRows={textAreaRows}
            maxRows={textAreaRows}
            placeholder={this.props.promptDetail.placeholder}
            label={this.props.promptDetail.label}
            updateInputField={this.onPromptTextChange}
            ref={ref => (this.promptTextRef = ref)}
            value={this.state.promptText}
            autoFocus={true}
            onEnter={this.onPromptEnter}
            customValidation={customValidationType && this.customValidation}
            testId={`${testId}-promptText`}
          />
        );
    }
  };

  render() {
    const modalContentClass = classNames(
      classes.modalContent,
      this.props.size
        ? classes["Modal--" + this.props.size]
        : classes["Modal--md"],
      this.props.customModalContentClass
    );
    const {
      promptDetail: { customValidationType },
      promptBoxType,
      modalBodyStyle,
      button1Styles,
      button2Styles,
      button1Props,
      button2Props,
      button1,
      button2,
      warningTextStyles,
      headerTitleStyles,
      modalTitle,
      modalTitleSubText,
      modalTitleSubTextStyles,
      cancelButtonStyle,
      textAreaRows,
      closeButtonSize,
      showWarningOnTop,
      showWarningOnBottom,
      customComponent,
      testId,
    } = this.props;

    return (
      <UIModal
        isOpen={true}
        modalContent={modalContentClass}
        onRequestClose={this.onCancelClick}
        overlayContainer={classes.modalOverlayContainer}
      >
        <React.Fragment>
          {!!this.props.modalTitle && (
            <div
              className={classes.modalHeader}
              style={this.props.headerStyles}
            >
              <div style={headerTitleStyles}>
                {modalTitle}
                {!!modalTitleSubText && (
                  <div style={modalTitleSubTextStyles}>{modalTitleSubText}</div>
                )}
              </div>
              {this.props.showCloseButton && (
                <div style={cancelButtonStyle}>
                  <IconButton
                    icon={<CloseOutlined />}
                    onClick={this.onCancelClick}
                    size={closeButtonSize}
                    _legacy_variant={"plain"}
                    variant="neutral"
                    type="plain"
                    testId={`${testId}-close`}
                  />
                </div>
              )}
            </div>
          )}

          <div
            className={classes.modalBody}
            style={modalBodyStyle}
            data-test-id={`${testId}:dialogbody`}
          >
            {this.props.warningText &&
              showWarningOnTop &&
              !showWarningOnBottom && (
                <div
                  className={classes.warningTextTop}
                  style={warningTextStyles}
                >
                  {this.props.warningText}
                </div>
              )}
            {this.props.isPromptBox ? (
              this.renderPromptBoxComponent()
            ) : (
              <React.Fragment>
                {this.props.modalBody}
                {this.props.warningText &&
                  showWarningOnBottom &&
                  !showWarningOnTop && (
                    <div
                      className={classes.warningTextBottom}
                      style={warningTextStyles}
                    >
                      {this.props.warningText}
                    </div>
                  )}
              </React.Fragment>
            )}
            {customComponent && customComponent()}
          </div>

          <div
            className={classes.modalFooter}
            style={this.props.footerContainerStyle}
          >
            {!!button1 && (
              <div className={classes.button1Div} style={button1Styles}>
                <Button
                  onClick={this.onClickButton1}
                  testId={`${testId}-primaryButton`}
                  {...button1Props}
                >
                  {button1}
                </Button>
              </div>
            )}
            {!!button2 && (
              <div className={classes.button2Div} style={button2Styles}>
                <Button
                  onClick={this.onClickButton2}
                  testId={`${testId}-secondaryButton`}
                  {...button2Props}
                >
                  {button2}
                </Button>
              </div>
            )}
          </div>
        </React.Fragment>
      </UIModal>
    );
  }
}

DialogueBoxV2.propTypes = {
  size: PropTypes.string,
  modalTitle: PropTypes.string,
  modalTitleSubText: PropTypes.string,
  modalBody: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  button1: PropTypes.string,
  button2: PropTypes.string,
  toggleDialogueBoxDisplay: PropTypes.func,
  onClickButton2: PropTypes.func,
  onClickButton1: PropTypes.func,
  isPromptBox: PropTypes.bool,
  promptBoxType: PropTypes.string,
  promptDetail: PropTypes.any,
  modalBodyStyle: PropTypes.object,
  button1Props: PropTypes.object,
  button2Props: PropTypes.object,
  warningTextStyles: PropTypes.object,
  modalTitleSubTextStyles: PropTypes.object,
  cancelButtonStyle: PropTypes.object,
  textAreaRows: PropTypes.number,
  closeButtonSize: PropTypes.string,
  customComponent: PropTypes.func,
  shouldCloseOnButtonClick: PropTypes.bool,
};

DialogueBoxV2.defaultProps = {
  isPromptBox: false,
  promptBoxType: "InputTextField",
  warningText: "",
  modalTitleSubText: "",
  footerContainerStyle: {},
  promptDetail: {
    label: "",
    placeholder: "",
    checkValidation: false,
    promptText: "",
  },
  modalBodyStyle: {},
  button1Props: {},
  button2Props: {},
  button1Styles: {},
  button2Styles: {},
  button1: "",
  button2: "",
  headerStyles: {},
  showCloseButton: true,
  warningTextStyles: {},
  headerTitleStyles: {},
  modalTitleSubTextStyles: {
    color: "#717171",
    fontSize: "1.4rem",
    marginTop: "6px",
    fontWeight: "500",
  },
  cancelButtonStyle: {},
  textAreaRows: 3,
  closeButtonSize: "large",
  showWarningOnTop: false,
  showWarningOnBottom: false,
  shouldCloseOnButtonClick: true,
  testId: "DialogueBoxV2",
};

export default DialogueBoxV2;
